<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-people position-left"></i>
            <span class="text-semibold">Activities</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <a (click)="getActivityFilter('')" type="button" class="btn btn-icon btn-sm bg-brown btn-rounded">

              <i class="icon-reload-alt position-left"></i> Refresh</a>
            <a type="button" class="btn btn-icon btn-sm bg-brown btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-left:30px;">
      <div class="col-md-3 form-group required">
        <span style="float:left" class="control-label">Filter by: </span>
        <select name="status" required [(ngModel)]="filter" (ngModelChange)="getActivityFilter(filter)"
          class="form-control">
          <option selected disabled>Region</option>
          <option value="&region=">All</option>
          <option value="&region=addis ababa">Addis Ababa</option>
          <option value="&region=afar">Afar</option>
          <option value="&region=oromiya">Oromiya</option>
          <option value="&region=amhara">Amhara</option>
          <option value="&region=tigray">Tigray</option>
          <option value="&region=harari">Amhara</option>
          <option value="&region=sidama">Sidama</option>
          <option value="&region=benishangul">Benishangul</option>
          <option value="&region=diredawa">Diredawa</option>
          <option value="&region=gambela">Gambela</option>
          <option value="&region=somali">Somali</option>
          <option value="&region=snnp">SNNP</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div>
    <div class="panel-body">
      <table class="table datatable-column-search-inputs">
        <thead>
          <tr>
            <th>User</th>
            <th>Model</th>
            <th>Message</th>
            <th>Remark</th>
            <th>Created</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let activity of activities | paginate: { id: 'activities',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
            <td>
              <div class="media">
                <span class="media-left">
                  <img *ngIf="!activity.avatar" src="assets/img/userm.png" width="40" height="40"
                    class="img-circle img-md" alt="">
                  <a href="javascript:void(0)" (click)="setActivityUrl(activity.imageUrl)" data-toggle="modal"
                    data-target="#activityImModal"><img [src]="activity.imageUrl" width="40" height="40"
                      class="img-circle img-md" alt=""></a>
                </span>
                <div class="media-left">
                  <!-- <a href="" [routerLink]="['/customer',activity.id]">{{activity?.user.data.username}}</a> -->
                  <a href="" [routerLink]="['/activity',activity.id]">{{activity?.user.data.username}}
                    <div class="text-muted text-size-small">
                      {{activity?.user.data.phone_number}}, {{activity?.email}}
                    </div>
                  </a>
                </div>
              </div>
            </td>
            <td>
              <div class="media">
                <div class="media-left">{{activity?.city}}
                  <div class="text-muted text-size-small">
                    {{activity?.sub_city}}
                  </div>
                </div>
              </div>
            </td>
            <td>{{activity.house_no}}</td>
            <td>
              <div class="media">
                <div class="media-left">{{activity?.emergency_contact}}
                  <div class="text-muted text-size-small">
                    {{activity?.emergency_phone}}
                  </div>
                </div>
              </div>
            </td>
            <td>{{activity.created_at|date:short}}</td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a [routerLink]="['/customeradd']"
                        [queryParams]="{'id':activity.id,'user':activity?.user.data.id}">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li>
                      <a href="">
                        <i class="icon-file-excel"></i>Delete</a>
                    </li>
                    <li class="divider"></li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="activities.length <= 0">
            <td colspan="7" class="text-center"><i class="icon-info22">&nbsp;</i> No Activities Found</td>
          </tr>
        </tbody>
      </table>

      <!-- <div class="text-center">
        <br>

        <pagination-controls id="useres" previousLabel="Pre" nextLabel="Next" (pageChange)="getNewses()">
        </pagination-controls>

        <br>
      </div> -->

      <div class="row">
        <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
        <div class="text-center">
          <pagination-controls id="activities" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>
          <br>
        </div>
      </div>

    </div>
  </div>
</div>
